export const ExperimentNames = {
    // Forever experiment
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    EventDetailsSlotsViewer: 'specs.events.ui.EventDetailsSlotsViewer',
    DashboardSlots: 'specs.events.ui.DashboardSlots',
    PageInstallFlow: 'specs.events.ui.PageInstallFlow',
    CategoryIdVeloUpdate: 'specs.events.ui.CategoryIdVeloUpdate',
    PricingPlansEventsFlexiForm: 'specs.events.ui.PricingPlansEventsFlexiForm',
    MessagesNewDesign: 'specs.events.ui.MessagesNewDesign',
    RsvpDynamicMessages: 'specs.events.ui.RsvpDynamicMessages',
    RicosBusinessManager: 'specs.events.ui.Ricos',
    RicosViewer: 'specs.events.ui.RicosViewer',
    SausageIntegration: 'specs.events.ui.SausageIntegration',
    RemoveLiveVideoAccess: 'specs.events.ui.RemoveLiveVideoAccess',
    UpdatedClassicAddPanel: 'specs.events.ui.UpdatedClassicAddPanel',
    HoppEntryPoint: 'specs.events.ui.HoppEntryPoint',
    LibraryBasedIOD: 'specs.events.ui.LibraryBasedIOD',
    MultidayEventsCalendar: 'specs.events.ui.MultidayEventsCalendar',
    UpdatePaymentTermsPaypal: 'specs.events.ui.UpdatePaymentTermsPaypal',
    UpdatePaymentTermsSquare: 'specs.events.ui.UpdatePaymentTermsSquare',
    RecurringEventsImprovements: 'specs.events.ui.RecurringEventsImprovements',
    CheckInBanner: 'specs.events.ui.CheckInBanner',
    DonationInputFix: 'specs.events.ui.DonationInputFix',
    SettingsPanelUpdatedTranslations: 'specs.events.ui.SettingsPanelUpdatedTranslations',
    EventsListRedesign: 'specs.events.ui.EventsListRedesign',
    DisableEventCreationForPaypal: 'specs.events.ui.DisableEventCreationForPaypal',
    DescriptionVisibility: 'specs.events.ui.DescriptionVisibility',
    ExpressCheckout: 'specs.events.ui.ExpressCheckout',
    NewKBArticlesInTicketPreview: 'specs.events.ui.NewKBArticlesInTicketPreview',
    GuestInfoDeletedFields: 'specs.events.ui.GuestInfoDeletedFields',
    CouponInputEdit: 'specs.events.ui.CouponInputEdit',
    AddMultipleGuestsManually: 'specs.events.ui.AddMultipleGuestsManually',
    SingleEventNoRegistrationTextSetting: 'specs.events.ui.SingleEventNoRegistrationTextSetting',
    InvoicesLegalText: 'specs.events.ui.InvoicesLegalText',
    LoadMoreButtonImprovements: 'specs.events.ui.LoadMoreButtonImprovements',
    BMContentUpdates: 'specs.events.ui.BMContentUpdates',
    EventsApps: 'specs.events.ui.EventsApps',
    TicketMoreInfoButtonSetting: 'specs.events.ui.TicketMoreInfoButtonSetting',
    AiAssistant: 'specs.events.ui.AiAssistant',
    NewPolicyFontColor: 'specs.events.ui.NewPolicyFontColor',
    ServiceFeeEnforcementUpdates: 'specs.events.ui.ServiceFeeEnforcementUpdates',
    UpdatedCheckoutSummary: 'specs.events.ui.UpdatedCheckoutSummary',
    CategoriesUXImprovements: 'specs.events.ui.CategoriesUXImprovements',
    GuestListDefaultSort: 'specs.events.ui.GuestListDefaultSort',
    UpdatePaymentMethodEnabled: 'specs.events.ui.UpdatePaymentMethodEnabled',
    AutomationV3Enabled: 'automations.SiteOnV3AutomationsBuilder',
    OfferExpressCheckout: 'specs.events.ui.OfferExpressCheckout',
    WidgetSEOTags: 'specs.events.ui.WidgetSEOTags',
    AddMultipleGuestsManuallyRSVP: 'specs.events.ui.AddMultipleGuestsManuallyRSVP',
};
//# sourceMappingURL=experiments.js.map